import React from "react"
import types from "prop-types"
import { formOptionShape } from "utils/propTypeShapes"
import { FormsyHiddenInput } from "shared/inputs"
import { MultiFormSelect } from "shared/selects"
import FieldLabel from "shared/FieldLabel"

const BaseFormIdField = ({ forms, selectedFormIds, onChange }) => (
  <FieldLabel text="Form to copy">
    <MultiFormSelect
      options={forms}
      value={selectedFormIds}
      onChange={onChange}
    />
    <FormsyHiddenInput
      name="base_form_ids"
      required
      value={selectedFormIds}
    />
  </FieldLabel>
)

BaseFormIdField.propTypes = {
  forms: types.arrayOf(formOptionShape).isRequired,
  selectedFormIds: types.arrayOf(Number).isRequired,
  onChange: types.func.isRequired,
}

export default BaseFormIdField
